module.exports = __webpack_public_path__ + "img/ico_like.45d73bc6.svg";